import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed, reactive, ref, watch } from 'vue'
import { useReflectiveInjector } from '@tanbo/vue-di-plugin'
import { useI18n } from 'vue-i18n'
import { useCmTableListRefresh } from '@/hooks/use-cm-table-list-refresh'
import CmTable from '@/components/cmTable/index.vue'
import type { TableOpt } from '@/components/cmTable/types'
import { TerminalListService, RequestParams, ResponseData } from './terminal-list.service'
import { listCol } from '@/utils/list-columns-i18n'
import { formatTimeStamp } from '@/utils/time'


export default /*#__PURE__*/_defineComponent({
  __name: 'terminal-list',
  props: {
    peripheralId: { default: '' },
    timeRange: { default: 1 }
  },
  setup(__props: any) {

const props = __props

const { t, locale } = useI18n()
const injector = useReflectiveInjector([TerminalListService])
const service = injector.get(TerminalListService)

const tableRef = ref()
const { refreshList } = useCmTableListRefresh(tableRef)

const queryParams = reactive<RequestParams>({
  page: 1,
  limit: 20,
  peripheral_id: props.peripheralId,
  time_range: props.timeRange
})

function formatDeviceStatus (raw: unknown) {
  const v = Number(raw)
  if (v === 1) return t('responseHandle.terminalLoginOnline')
  if (v === 2) return t('responseHandle.terminalLoginOffline')
  if (v === 4) return t('usbPolicy.terminalStatusExited')
  return '--'
}

function dataApi (params: RequestParams) {
  return service.getPeripheralcontrolViewPeripheralAccessedRecordsGet({
    ...params,
    peripheral_id: props.peripheralId,
    time_range: props.timeRange,
  })
}

function dataFormate (rows: ResponseData['list']) {
  return rows.map((row) => ({
    ...row,
    login_status: Number(row.device_status),
  }))
}

const tableOpt = computed<TableOpt>(() => {
  void locale.value
  return {
    height: '100%',
    path: 'list',
    totalPath: 'total',
    showActionBar: false,
    showForm: false,
    showTip: false,
    showRightToolbar: false,
    bodyStyle: 'padding: 0 16px 16px;',
    columns: [
      { label: listCol(t, 'computerName'), prop: 'computer_name', type: 'COMPUTER', columnOpt: { minWidth: 180 } },
      { label: listCol(t, 'groupName'), prop: 'group_name' },
      { label: listCol(t, 'userMark'), prop: 'user_mark', columnOpt: { minWidth: 130 } },
      { label: listCol(t, 'ipAddress'), prop: 'system_ip', type: 'IP', columnOpt: { minWidth: 150 } },
      { label: t('usbPolicy.terminalStatus'), prop: 'device_status', formatter: (_row: unknown, value: unknown) => formatDeviceStatus(value) },
      { label: listCol(t, 'triggerPolicy'), prop: 'strategy_name', formatter: (_row,value) => value || '--', columnOpt: { minWidth: 120 }, showOverflow: true },
      {
        label: listCol(t, 'accessTime'),
        prop: 'access_time',
        columnOpt: { minWidth: 160 },
        formatter: (_row: unknown, value: unknown) => {
          const ts = Number(value)
          return formatTimeStamp(Number(value), 'YYYY-MM-DD HH:mm')
        }
      },
    ]
  }
})

watch(
  () => ({ peripheralId: props.peripheralId, timeRange: props.timeRange }),
  ({ peripheralId, timeRange }) => {
    queryParams.peripheral_id = peripheralId || ''
    queryParams.time_range = Number(timeRange || 1)
    queryParams.page = 1
    void refreshList()
  },
  { immediate: true }
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(CmTable, {
    ref_key: "tableRef",
    ref: tableRef,
    "table-opt": tableOpt.value,
    api: dataApi,
    "data-formate": dataFormate,
    modelValue: queryParams,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((queryParams) = $event)),
    "page-option": { pageNumName: 'page', pageSizeName: 'limit' }
  }, null, 8, ["table-opt", "modelValue"]))
}
}

})